gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

if (ScrollTrigger.isTouch === 1) {
    // Enable normalizeScroll only on touch devices
    //   ScrollTrigger.normalizeScroll(true);
}

ScrollTrigger.config({
    // ignoreMobileResize: true
});

document.addEventListener('DOMContentLoaded', () => {
    ScrollTrigger.sort();
    ScrollTrigger.refresh(true);
    // HOME SECTION 7
    // var coHS7splide = new Splide('.co-home-s7-swiper', {
    //     type: 'loop',
    //     drag: 'free',
    //     autoWidth: true,
    //     snap: true,
    //     speed: 1200,
    //     // clones: 10,
    //     focus: 'center',
    //     updateOnMove: true,
    //     //   dragMinThreshold: 50,
    //     // flickPower: 1000,
    //     //   perPage: 3,
    //     start: 3,
    // });

    // coHS7splide.mount();
    //HOME SECTION 7

    if (window.matchMedia("(min-width: 989px)").matches) {

    }

    gsap.set('sticky-header', {
        y: -30,
        scale: 1,
        opacity: 0,
        transition: 0
    });
    // gsap.set('.co-home-s1-sub-logo', { y: 30, scale: 1.05, transition: 0 });

    gsap.to('sticky-header', {
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.75,
        opacity: 1,
        ease: "Power4.inOut",
        delay: 0.3,
    });


    imageScrollParallax('.co-article-s1-media img', '.co-article-s1', "20%", '50%', 0, 15);


    // foter reveal
    // const overlaySec4 = document.querySelector('footer.footer');
    // function getPrevSection(curr) {
    //     const parentSection = curr.closest('.shopify-section');
    //     if (!parentSection) return null;

    //     const prevSection = parentSection.previousElementSibling;
    //     return prevSection;
    // }

    // function getFirstDivInPrevSection(curr) {
    //     const prevSection = getPrevSection(curr);
    //     if (!prevSection) return null;

    //     // get the first <div> inside that previous section
    //     const firstDiv = prevSection.querySelector('div');
    //     return firstDiv || null;
    // }
    // const overlaySec4Pin = getFirstDivInPrevSection(overlaySec4);

    // const scrollTriggerFooter = '';


    //footer reveal

    if (document.documentElement.classList.contains('shopify-design-mode')) {
        gsap.set('.coFadeIn', { opacity: 1, y: 0 });
        gsap.set('.coFade', { opacity: 1, y: 0 });
        gsap.set('.coFadeInMarquee', { opacity: 1, y: 0 });
        gsap.set('.coZoomDown', { opacity: 1, scale: 1 });
    } else {
        gsap.set('.coFadeIn', { opacity: 0, y: 30 });
        ScrollTrigger.batch(".coFadeIn", {
            interval: 0,
            batchMax: 9,
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                y: 0,
                duration: 1.2,
                stagger: 0.2,
                delay: 0.2,
                ease: "power2.out",
            }),
        });

        gsap.set('.coFade', { opacity: 0, y: 0 });
        ScrollTrigger.batch(".coFade", {
            interval: 0,
            batchMax: 1,
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                y: 0,
                duration: 1.2,
                stagger: 0.2,
                delay: 0.2,
                ease: "power2.out",
            }),
        });

        gsap.set('.coFadeInMarquee', { opacity: 0, y: 50 });
        ScrollTrigger.batch(".coFadeInMarquee", {
            interval: 0,
            // batchMax: 20,
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                y: 0,
                duration: 1.2,
                stagger: 0.1,
                delay: 0.1,
                ease: "power2.out",
            }),
        });

        gsap.set('.coZoomDown', { opacity: 1, scale: 1.05 });
        ScrollTrigger.batch(".coZoomDown", {
            interval: 0,
            // batchMax: 20,
            onEnter: batch => gsap.to(batch, {
                opacity: 1,
                scale: 1,
                duration: 1.2,
                stagger: 0.2,
                delay: 0.1,
                ease: "power2.out",
            }),
        });
    }


    footerReveal();
});


window.addEventListener('resize', function (event) {
    ScrollTrigger.sort();
    ScrollTrigger.refresh(true);
}, true);

// if (typeof (document.getElementsByClassName('.co-home-section-5')) != 'undefined' && document.getElementsByClassName('.co-home-section-5') != null) {

//     imageScrollScale('.co-home-section-5-image--left img', '.co-home-section-5', "25%", 'bottom bottom', 1, 1.2);
//     imageScrollScale('.co-home-section-5-image--right img', '.co-home-section-5', "25%", 'bottom bottom', 1.2, 1);
// }

function imageScrollParallax(target, trigger, triggerPosStart, triggerPosEnd, yFrom, yTo) {
    // default paramaters
    target = target || false;
    trigger = trigger || false;
    triggerPosStart = triggerPosStart || 'top';
    triggerPosEnd = triggerPosEnd || 'bottom';
    yFrom = yFrom || 0;
    yTo = yTo || 1;

    gsap.set(target, { yPercent: yFrom });
    gsap.to(target, {
        scrollTrigger: {
            trigger: trigger,
            toggleActions: "restart none none reverse",
            // markers: true,
            start: "" + triggerPosStart + " bottom",
            end: "" + triggerPosEnd + " top",
            scrub: true,
            invalidateOnRefresh: true
        },
        yPercent: yTo
    });
}

function footerReveal() {
    if (window.matchMedia("(min-width: 989px)").matches) {
        setTimeout(function () {
            // const scrollTriggerFooter = ScrollTrigger.create({
            //     trigger: 'footer.footer',
            //     pin: '.co_footer',
            //     pinSpacing: false,
            //     start: 'top bottom',
            //     end: '99.99% bottom',
            //     // markers: true,
            //     invalidateOnRefresh: true
            // });

            window.footerTL = gsap.timeline({
                scrollTrigger: {
                    trigger: 'footer.footer',
                    pin: '.co_footer',
                    pinSpacing: false,
                    start: 'top bottom',
                    end: '99.99% bottom',
                    invalidateOnRefresh: true
                }
            });

            // const tl = gsap.timeline({
            //     scrollTrigger: {
            //         trigger: 'footer.footer',
            //         pin: '.co_footer',
            //         pinSpacing: false,
            //         start: 'top bottom',
            //         end: '99.99% bottom',
            //         // markers: true,
            //         invalidateOnRefresh: true
            //     }
            // });

            accItemsHomes4 = document.querySelectorAll('.co-home-s4-accordion--title');

            accItemsHomes4.forEach(element => {


                element.addEventListener('click', function (event) {
                    // event.preventDefault();
                    // console.log(element);
                    setTimeout(function () {
                        footerTL.scrollTrigger.refresh(true);
                    }, 300);
                });

            });
            document.addEventListener('click', function (event) {
                // footerTL.scrollTrigger.refresh(true);
            });
        }, 300);


    }
}


// (() => {
//   const USER_EVENTS = ['click', 'input', 'change', 'keydown'];
//   let userTriggered = false;
//   let refreshTimeout = null;

//   // 1️⃣ Detect user intent
//   USER_EVENTS.forEach(event => {
//     document.addEventListener(
//       event,
//       () => {
//         userTriggered = true;
//       },
//       true // capture phase
//     );
//   });

//   // 2️⃣ Observe DOM changes after user interaction
//   const observer = new MutationObserver(() => {
//     if (!userTriggered) return;

//     clearTimeout(refreshTimeout);

//     refreshTimeout = setTimeout(() => {
//       if (window.scrollTriggerFooter?.refresh) {
//         scrollTriggerFooter.refresh(true);
//         scrollTriggerHS7.refresh(true);
//       }
//       userTriggered = false;
//     }, 80);
//   });

//   // 3️⃣ Start observing
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//   });
// })();
